export default __webpack_public_path__ + "static/media/tumblr-icon.4d9b87e2.svg";